import { render } from "./OrderBevestigingenPage.vue?vue&type=template&id=6e0aed1c&scoped=true"
import script from "./OrderBevestigingenPage.vue?vue&type=script&lang=js"
export * from "./OrderBevestigingenPage.vue?vue&type=script&lang=js"

import "./OrderBevestigingenPage.vue?vue&type=style&index=0&id=6e0aed1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0aed1c"]])

export default __exports__